import React from 'react';
import {
  BadgeOutlinedIcon,
  Link,
  LocationOnOutlinedIcon,
  NotesOutlinedIcon,
  OpenInNewIcon,
  Stack,
} from '@billda/design-system';
import { SectionHeader } from './SectionHeader';
import SiteNameCodeFields from './SiteNameCodeFields';
import What3WordsField from './What3WordsField';
import NotesField from './NotesField';

const SiteInformationStep: React.FC = () => (
  <div data-testid="site-information-step">
    <Stack spacing={3}>
      <div className="rounded-2xl border border-border-default bg-surface-default p-6">
        <Stack spacing={2.5}>
          <SectionHeader
            icon={<BadgeOutlinedIcon className="size-5" aria-hidden="true" />}
            title="Identity"
            description="Give your site a name and a unique 4-character code"
          />
          <SiteNameCodeFields />
        </Stack>
      </div>

      <div className="rounded-2xl border border-border-default bg-surface-default p-6">
        <Stack spacing={2.5}>
          <SectionHeader
            icon={
              <LocationOnOutlinedIcon className="size-5" aria-hidden="true" />
            }
            title="Location"
            description="Helps your team navigate directly to the site in the app"
          />
          <Link
            href="https://what3words.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 type-caption"
            data-testid="what3words-external-link"
          >
            Don&apos;t know your address? Find it on what3words.com
            <OpenInNewIcon className="size-3" aria-hidden="true" />
          </Link>
          <What3WordsField />
        </Stack>
      </div>

      <div className="rounded-2xl border border-border-default bg-surface-default p-6">
        <Stack spacing={2.5}>
          <SectionHeader
            icon={<NotesOutlinedIcon className="size-5" aria-hidden="true" />}
            title="Notes"
            description="Optional description or additional information about the site"
          />
          <NotesField />
        </Stack>
      </div>
    </Stack>
  </div>
);

export default SiteInformationStep;
